var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.9925L15.42 6.9L15.675 4.1325L12.9675 3.5175L11.55 1.125L9 2.22L6.45 1.125L5.0325 3.5175L2.325 4.125L2.58 6.9L0.75 8.9925L2.58 11.085L2.325 13.86L5.0325 14.475L6.45 16.875L9 15.7725L11.55 16.8675L12.9675 14.475L15.675 13.86L15.42 11.0925L17.25 8.9925ZM14.2875 10.1025L13.8675 10.59L13.9275 11.2275L14.0625 12.69L12.0075 13.155L11.6775 13.71L10.935 14.97L9.6 14.3925L9 14.1375L8.4075 14.3925L7.0725 14.97L6.33 13.7175L6 13.1625L3.945 12.6975L4.08 11.2275L4.14 10.59L3.72 10.1025L2.7525 9L3.72 7.89L4.14 7.4025L4.0725 6.7575L3.9375 5.3025L5.9925 4.8375L6.3225 4.2825L7.065 3.0225L8.4 3.6L9 3.855L9.5925 3.6L10.9275 3.0225L11.67 4.2825L12 4.8375L14.055 5.3025L13.92 6.765L13.86 7.4025L14.28 7.89L15.2475 8.9925L14.2875 10.1025Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5675 10.3125L5.8275 8.565L4.7175 9.6825L7.5675 12.54L13.0725 7.02L11.9625 5.9025L7.5675 10.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.b559762d.svg";
export { ForwardRef as ReactComponent };